import styled from 'styled-components';

export const CenterCointer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 214px;
  justify-content: center;
  position: relative;
  top: -90px;
`;
CenterCointer.displayName = 'CenterCointer';

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 2px;
  width: 12px;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Container = styled.section`
  font-family: 'Roboto', sans-serif;
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 60px;
  margin-top: 90px;
`;
Container.displayName = 'Container';

export const Logo = styled.img`
  margin-bottom: -8px;
`;
Logo.displayName = 'Logo';

export const Points = styled.div`
  color: #2a002e;
  line-height: 56px;
  min-width: 45px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  background-color: #02fe89;
  color: #2a002e;
  display: flex;
  height: 64px;
  justify-content: center;
  text-align: center;
  width: 142px;
`;
PointsContainer.displayName = 'PointsContainer';

export const Space = styled.div`
  font-size: 30px;
  position: relative;
  top: -2px;
`;
Space.displayName = 'Space';

export const TeamContainer = styled.div`
  display: flex;
  height: 64px;
`;
TeamContainer.displayName = 'TeamContainer';

export const TeamName = styled.div`
  align-items: center;
  background: #2a002e;
  color: #efefef;
  display: flex;
  justify-content: center;
  letter-spacing: 2px;
  line-height: 56px;
  min-width: 118px;
  padding: 0 16px;
`;
TeamName.displayName = 'TeamName';

export const TimerContainer = styled.div`
  align-items: center;
  background-color: #efefef;
  box-sizing: content-box;
  display: flex;
  height: 60px;
  justify-content: center;
  width: 142px;
`;
TimerContainer.displayName = 'TimerContainer';

export const Timer = styled.div`
  color: #2a002e;
  font-size: 42px;
  font-weight: 500;
  text-align: center;
`;
Timer.displayName = 'Timer';
